import NextImage from '@/components/NextImage';
import styles from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function EnergyHousekeeper() {
    const { useLang } = useGlobal();
    const { t } = useLang('PoweroceanSinglePhase.EnergyHousekeeper');

    return (
        <div className={`${styles.energyHousekeeper}`}>
            <div className="solution-item">
                <div className="row-item">
                    <div className="container">
                        <div className="text-box">
                            <>
                                <div className="sub-title">{t('item_label1')}</div>
                                <h2 className="title">{t('item_title1')}</h2>
                                <div className="desc">{t('item_desc1')}</div>
                            </>
                        </div>
                    </div>
                    <div className="bg-img">
                        <NextImage src="https://websiteoss.ecoflow.com/upload/image/1762830573260/1_eu.png" alt={t('item_title1')} />
                    </div>
                    <div className="bg-img-h5">
                        <NextImage src="https://websiteoss.ecoflow.com/upload/image/1762830582096/1_eu_h5.png" alt={t('item_title1')} />
                    </div>
                </div>
                <div className="row-item2">
                    <div className="item">
                        <div className="text-box">
                            <h3 className="title">{t('item_title2')}</h3>
                            <div className="desc">{t('item_desc2')}</div>
                        </div>
                        <div className="bg-img">
                            <NextImage src="https://websiteoss.ecoflow.com/upload/image/1761275636084/Bills_uk.png" alt={t('item_title2')} />
                        </div>
                        <div className="bg-img-h5">
                            <NextImage src="https://websiteoss.ecoflow.com/upload/image/1761275636307/Bills_uk_h5.png" alt={t('item_title2')} />
                        </div>
                    </div>
                    <div className="item">
                        <div className="text-box">
                            <h3 className="title">{t('item_title3')}</h3>
                            <div className="desc">{t('item_desc3')}</div>
                        </div>
                        <div className="bg-img">
                            <NextImage src="https://websiteoss.ecoflow.com/upload/image/1762940443915/3-eu.png" alt={t('item_title3')} />
                        </div>
                        <div className="bg-img-h5">
                            <NextImage src="https://websiteoss.ecoflow.com/upload/image/1762940449949/3-eu-h5.png" alt={t('item_title3')} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export const getStaticProps = async () => {
    return {
        props: {},
    };
};
